import { FC, ReactElement } from "react"

export type ShowType = {
    condition: boolean;
    children: ReactElement;
}

export const Show: FC<ShowType> = ({ condition, children }) => condition ? children : null